import axios from 'axios'
const reportSectionUrl = '/api/templates/sections'

export default class SectionTemplateService {
    // Get Report sections
    static getReportSectionTemplates() {
        return new Promise(async (resolve, reject) => {
            try {
                let results = await axios.get(reportSectionUrl)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get Report Section by ID
    static getReportSectionTemplateById(sectionId) {
        return new Promise(async (resolve, reject) => {
            try {
                let sectionUrl = `${reportSectionUrl}/${sectionId}`
                let result = await axios.get(sectionUrl)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Create Report Section
    static createReportSection(data) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.post(reportSectionUrl, data)
                resolve(result.data)
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Update Report Section by ID
    static updateReportSection(sectionId, data) {
        return new Promise(async (resolve, reject) => {
            try {
                let sectionUrl = `${reportSectionUrl}/${sectionId}`
                let result = await axios.put(sectionUrl, data)
                resolve(result)                
            } catch (err) {
                reject(err)                
            }
        })
    }

    // Delete Report Section by ID
    static deleteReportSection(sectionId) {
        return new Promise(async (resolve, reject) => {
            try {
                let sectionUrl = `${reportSectionUrl}/${sectionId}`
                let result = await axios.delete(sectionUrl)
                resolve(result)
            } catch (err) {
                reject(err)                
            }
        })
    }
}